/**
 * @generated SignedSource<<416f2de950214dd653e024e941a9eaeb>>
 * @relayHash 169d81baefc7ae2180877a0a1394e705
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 52ad1f2cc6e3f90d2b258f01ac3517ee9db71895944a0d4acaf80ea8a4b4a7d1

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraAtlassianIntelligenceFeatureEnum = "AI_MATE" | "NATURAL_LANGUAGE_TO_JQL" | "%future added value";
export type JiraIssueSearchAggregationFunction = "ROLLUP" | "%future added value";
export type JiraIssueSearchOperationScope = "NIN_GLOBAL" | "NIN_GLOBAL_SCHEMA_REFACTOR" | "NIN_GLOBAL_SHADOW_REQUEST" | "NIN_PROJECT" | "NIN_PROJECT_SCHEMA_REFACTOR" | "NIN_PROJECT_SHADOW_REQUEST" | "TIMELINE_PROJECT" | "%future added value";
export type JiraSoftwareIssueSearchCustomInputContext = "BACKLOG" | "BOARD" | "NONE" | "%future added value";
export type JiraIssueSearchInput = {
  childIssuesInput?: JiraIssueSearchChildIssuesInput | null | undefined;
  customInput?: JiraIssueSearchCustomInput | null | undefined;
  filterId?: string | null | undefined;
  jql?: string | null | undefined;
  searchWithLastUsedJql?: boolean | null | undefined;
};
export type JiraIssueSearchChildIssuesInput = {
  filterByProjectKeys?: ReadonlyArray<string> | null | undefined;
  filterId?: string | null | undefined;
  jql?: string | null | undefined;
  namespace?: string | null | undefined;
  parentIssueKey: string;
  viewId?: string | null | undefined;
};
export type JiraIssueSearchCustomInput = {
  jiraSoftwareInput?: JiraSoftwareIssueSearchCustomInput | null | undefined;
  jiraTimelineInput?: JiraTimelineIssueSearchCustomInput | null | undefined;
};
export type JiraSoftwareIssueSearchCustomInput = {
  additionalJql?: string | null | undefined;
  context?: JiraSoftwareIssueSearchCustomInputContext | null | undefined;
  jiraEntityId: string;
};
export type JiraTimelineIssueSearchCustomInput = {
  additionalJql?: string | null | undefined;
  boardId: string;
  customFilterIds?: ReadonlyArray<string> | null | undefined;
  quickFilterIds?: ReadonlyArray<string> | null | undefined;
};
export type JiraIssueSearchOptions = {
  issueKey?: string | null | undefined;
};
export type JiraIssueSearchFieldSetsInput = {
  fieldSetIds?: ReadonlyArray<string> | null | undefined;
  viewInput?: JiraIssueSearchViewInput | null | undefined;
};
export type JiraIssueSearchViewInput = {
  context?: JiraIssueSearchViewFieldSetsContext | null | undefined;
  filterId?: string | null | undefined;
  namespace?: string | null | undefined;
  viewId?: string | null | undefined;
};
export type JiraIssueSearchViewFieldSetsContext = {
  filterContext?: JiraIssueSearchViewFieldSetFilterContext | null | undefined;
  issueContext?: JiraIssueSearchViewFieldSetsIssueContext | null | undefined;
  projectContext?: JiraIssueSearchViewFieldSetsProjectContext | null | undefined;
};
export type JiraIssueSearchViewFieldSetFilterContext = {
  filter?: string | null | undefined;
};
export type JiraIssueSearchViewFieldSetsIssueContext = {
  issueKey?: string | null | undefined;
};
export type JiraIssueSearchViewFieldSetsProjectContext = {
  issueType?: string | null | undefined;
  project?: string | null | undefined;
};
export type JiraIssueSearchStaticViewInput = {
  aggregationConfig?: JiraIssueSearchAggregationConfigInput | null | undefined;
  isGroupingEnabled?: boolean | null | undefined;
  isHideDoneEnabled?: boolean | null | undefined;
  isHierarchyEnabled?: boolean | null | undefined;
};
export type JiraIssueSearchAggregationConfigInput = {
  aggregationFields?: ReadonlyArray<JiraIssueSearchFieldAggregationInput> | null | undefined;
  canEnableAggregation?: boolean | null | undefined;
};
export type JiraIssueSearchFieldAggregationInput = {
  aggregationFunction?: JiraIssueSearchAggregationFunction | null | undefined;
  fieldId?: string | null | undefined;
  isEnabled?: boolean | null | undefined;
};
export type JiraIssueSearchViewConfigInput = {
  staticViewInput?: JiraIssueSearchStaticViewInput | null | undefined;
  viewInput?: JiraIssueSearchViewInput | null | undefined;
};
export type JiraIssueSearchScope = {
  operationScope?: JiraIssueSearchOperationScope | null | undefined;
  projectKey?: string | null | undefined;
};
export type JiraViewQueryInput = {
  boardIdAndItemQuery?: JiraViewBoardIdAndItemQuery | null | undefined;
  projectKeyAndItemQuery?: JiraViewProjectKeyAndItemQuery | null | undefined;
  viewId?: string | null | undefined;
};
export type JiraViewBoardIdAndItemQuery = {
  boardId: AGG$Long;
  cloudId: string;
  itemId: string;
};
export type JiraViewProjectKeyAndItemQuery = {
  cloudId: string;
  itemId: string;
  projectKey: string;
};
export type JiraIssueSearchSettings = {
  groupBy?: string | null | undefined;
  hideDone?: boolean | null | undefined;
  hierarchyEnabled?: boolean | null | undefined;
  jql?: string | null | undefined;
};
export type main_IssueNavigatorQuery$variables = {
  after?: string | null | undefined;
  amountOfColumns: number;
  atlassianIntelligenceProductFeature: JiraAtlassianIntelligenceFeatureEnum;
  before?: string | null | undefined;
  cloudId: string;
  dynamicSearchKey?: string | null | undefined;
  fieldSetsInput?: JiraIssueSearchFieldSetsInput | null | undefined;
  fieldSetsScope?: JiraIssueSearchScope | null | undefined;
  filterId?: string | null | undefined;
  first?: number | null | undefined;
  groupBy?: string | null | undefined;
  isPaginating?: boolean | null | undefined;
  issueSearchInput: JiraIssueSearchInput;
  jiraViewQueryInput?: JiraViewQueryInput | null | undefined;
  last?: number | null | undefined;
  namespace?: string | null | undefined;
  options?: JiraIssueSearchOptions | null | undefined;
  projectKey: string;
  saveJQLToUserHistory?: boolean | null | undefined;
  scope?: JiraIssueSearchScope | null | undefined;
  settings?: JiraIssueSearchSettings | null | undefined;
  shouldQueryConditionalFormatting: boolean;
  shouldQueryConditionalFormattingFromSavedView: boolean;
  shouldQueryHasChildren?: boolean | null | undefined;
  shouldQueryProject: boolean;
  staticViewInput?: JiraIssueSearchStaticViewInput | null | undefined;
  viewConfigInput?: JiraIssueSearchViewConfigInput | null | undefined;
  viewId?: string | null | undefined;
};
export type main_IssueNavigatorQuery$data = {
  readonly jira: {
    readonly jiraProjectByKey?: {
      readonly " $fragmentSpreads": FragmentRefs<"ConditionalFormattingSidebarContainer_project" | "container_issueNavigatorActionConditionalFormatting_ConditionalFormattingInner" | "issueSearch_issueNavigatorProject" | "main_issueNavigator_IssueNavigatorUI_project">;
    } | null | undefined;
    readonly userPreferences: {
      readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_IssueNavigator_userPreferences">;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_IssueNavigator_jira">;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_IssueNavigator_issueQuery">;
};
export type main_IssueNavigatorQuery = {
  response: main_IssueNavigatorQuery$data;
  variables: main_IssueNavigatorQuery$variables;
};
({
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiraninlastusedjqlrelayprovider": lastUsedJql_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider": isSavedListViewTechnicalChangesEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcisfrozencolumnsenabledrelayprovidertsx": isFrozenColumnsEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcbulkopsselectallrelayprovider": isBulkOpsSelectAllEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewenabledrelayprovider": isSavedListViewEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjscissuerankingrelayprovider": isIssueRankingEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider": isJscIFCEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider": isJSCAliasChangesEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewconditionalformattingenabledrelayprovider": isSavedViewConditionalFormattingEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider": isReparentingEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcfrontierformulafieldd1relayprovider": isFormulaFieldD1Enabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider": isInitialiseVirtualiserStateFromRelayStoreEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcmimicflatlistrsswhileuninitialisedrelayprovider": isMimicFlatlistRssWhileUninitialisedEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreducererendersrelayprovider": isJiraListReduceRerendersEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": isJscMergedColumnEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider": isJiraItrM4Exp3Enabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider": isIframePreviewPanelInSubtasksEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider": isJiraTimelineAnalyticsHarmonizationEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider": isAtlasProjectEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider": originalEstimateEditableFixFlag_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider": isFieldsByIdRemoved_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaifetchapptypeforuserassigneerelayprovider": shouldFetchAppUserType_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider": isJiraAiAgentAvatarSingleUserPickerEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider": isNinStrikethroughResolutionUpdateEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": isNumberFieldConfigurableEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider": isPlaceholderDataEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider": isJiraConfluencePageContentEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider": isJiraTimelineRollupsTechnicalGateEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerninrelayprovider": isJiraAiAgentAvatarSingleUserPickerNINEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyprojectsrelayprovider": isGroupByProjectsEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcgoalgroupheadersmartlinkrelayprovider": isGoalSmartLinkEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcisjirapaidlistninmergeonboardingmodalenabledrelayprovider": isPaidListNinMergeOnboardingModalEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesdogfoodingormergesupportenabledrelayprovider": isSavedListViewTechnicalChangesDogfoodingOrMergeSupportEnabled_provider
} as {
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcbulkopsselectallrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcfrontierformulafieldd1relayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcgoalgroupheadersmartlinkrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcgroupbyprojectsrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcisfrozencolumnsenabledrelayprovidertsx: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcisjirapaidlistninmergeonboardingmodalenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewconditionalformattingenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesdogfoodingormergesupportenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerninrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiraaifetchapptypeforuserassigneerelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiralistreducererendersrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiraninlastusedjqlrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjscissuerankingrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcmimicflatlistrsswhileuninitialisedrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider: {
    readonly get: () => boolean;
  };
});

import isAtlasProjectEnabled_provider from '@atlassian/jira-relay-provider/src/atlas-project-native-integration.relayprovider';
import isBulkOpsSelectAllEnabled_provider from '@atlassian/jira-relay-provider/src/bulk-ops-select-all.relayprovider';
import isFormulaFieldD1Enabled_provider from '@atlassian/jira-relay-provider/src/frontier-formula-field-d1.relayprovider';
import isGoalSmartLinkEnabled_provider from '@atlassian/jira-relay-provider/src/goal-group-header-smart-link.relayprovider';
import isPlaceholderDataEnabled_provider from '@atlassian/jira-relay-provider/src/goals-ssr-smart-card.relayprovider';
import isGroupByProjectsEnabled_provider from '@atlassian/jira-relay-provider/src/group-by-projects.relayprovider';
import isInitialiseVirtualiserStateFromRelayStoreEnabled_provider from '@atlassian/jira-relay-provider/src/initialise-virtualiser-state-from-relay-store.relayprovider';
import isFrozenColumnsEnabled_provider from '@atlassian/jira-relay-provider/src/is-frozen-columns-enabled.relayprovider';
import isIframePreviewPanelInSubtasksEnabled_provider from '@atlassian/jira-relay-provider/src/is-iframe-preview-panel-in-subtasks-enabled.relayprovider';
import isJiraItrM4Exp3Enabled_provider from '@atlassian/jira-relay-provider/src/is-jira-itr-m4-exp-3-enabled.relayprovider';
import isPaidListNinMergeOnboardingModalEnabled_provider from '@atlassian/jira-relay-provider/src/is-jira-paid-list-nin-merge-onboarding-modal-enabled.relayprovider';
import isJscIFCEnabled_provider from '@atlassian/jira-relay-provider/src/is-jsc-ifc-enabled.relayprovider';
import isSavedViewConditionalFormattingEnabled_provider from '@atlassian/jira-relay-provider/src/is-saved-list-view-conditional-formatting-enabled.relayprovider';
import isSavedListViewEnabled_provider from '@atlassian/jira-relay-provider/src/is-saved-list-view-enabled.relayprovider';
import isSavedListViewTechnicalChangesDogfoodingOrMergeSupportEnabled_provider from '@atlassian/jira-relay-provider/src/is-saved-list-view-technical-changes-dogfooding-or-merge-support-enabled.relayprovider';
import isSavedListViewTechnicalChangesEnabled_provider from '@atlassian/jira-relay-provider/src/is-saved-list-view-technical-changes-enabled.relayprovider';
import isFieldsByIdRemoved_provider from '@atlassian/jira-relay-provider/src/issue-view-dfo-remove-fields-by-id.relayprovider';
import isJiraAiAgentAvatarSingleUserPickerNINEnabled_provider from '@atlassian/jira-relay-provider/src/jira-ai-agent-avatar-single-user-picker-nin.relayprovider';
import isJiraAiAgentAvatarSingleUserPickerEnabled_provider from '@atlassian/jira-relay-provider/src/jira-ai-agent-avatar-single-user-picker.relayprovider';
import shouldFetchAppUserType_provider from '@atlassian/jira-relay-provider/src/jira-ai-fetch-apptype-for-user-assignee.relayprovider';
import isJiraConfluencePageContentEnabled_provider from '@atlassian/jira-relay-provider/src/jira-confluence-page-content-enabled.relayprovider';
import isJiraListReduceRerendersEnabled_provider from '@atlassian/jira-relay-provider/src/jira-list-reduce-rerenders.relayprovider';
import isReparentingEnabled_provider from '@atlassian/jira-relay-provider/src/jira-list-reparenting.relayprovider';
import lastUsedJql_provider from '@atlassian/jira-relay-provider/src/jira-nin-last-used-jql.relayprovider';
import isNumberFieldConfigurableEnabled_provider from '@atlassian/jira-relay-provider/src/jira-number-field-configuration-enabled.relayprovider';
import originalEstimateEditableFixFlag_provider from '@atlassian/jira-relay-provider/src/jira-original-estimate-editable-fix.relayprovider';
import isJiraTimelineAnalyticsHarmonizationEnabled_provider from '@atlassian/jira-relay-provider/src/jira-timeline-analytics-harmonization.relayprovider';
import isJiraTimelineRollupsTechnicalGateEnabled_provider from '@atlassian/jira-relay-provider/src/jira-timeline-rollups-technical-gate.relayprovider';
import isJSCAliasChangesEnabled_provider from '@atlassian/jira-relay-provider/src/jsc-alias-changes.relayprovider';
import isIssueRankingEnabled_provider from '@atlassian/jira-relay-provider/src/jsc-issue-ranking.relayprovider';
import isJscMergedColumnEnabled_provider from '@atlassian/jira-relay-provider/src/jsc-merged-column.relayprovider';
import isMimicFlatlistRssWhileUninitialisedEnabled_provider from '@atlassian/jira-relay-provider/src/mimic-flatlist-rss-while-uninitialised.relayprovider';
import isNinStrikethroughResolutionUpdateEnabled_provider from '@atlassian/jira-relay-provider/src/nin-resolution-strikethough-enabled.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "amountOfColumns"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "atlassianIntelligenceProductFeature"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "before"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "dynamicSearchKey"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fieldSetsInput"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fieldSetsScope"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filterId"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "groupBy"
},
v11 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isPaginating"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueSearchInput"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "jiraViewQueryInput"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "last"
},
v15 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "namespace"
},
v16 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "options"
},
v17 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectKey"
},
v18 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "saveJQLToUserHistory"
},
v19 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "scope"
},
v20 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "settings"
},
v21 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldQueryConditionalFormatting"
},
v22 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldQueryConditionalFormattingFromSavedView"
},
v23 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "shouldQueryHasChildren"
},
v24 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldQueryProject"
},
v25 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "staticViewInput"
},
v26 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "viewConfigInput"
},
v27 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "viewId"
},
v28 = {
  "kind": "Variable",
  "name": "isConditionalFormattingEnabled",
  "variableName": "shouldQueryConditionalFormatting"
},
v29 = {
  "kind": "Variable",
  "name": "isSavedViewConditionalFormattingEnabled",
  "variableName": "shouldQueryConditionalFormattingFromSavedView"
},
v30 = {
  "kind": "Variable",
  "name": "projectKey",
  "variableName": "projectKey"
},
v31 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v32 = [
  (v31/*: any*/)
],
v33 = [
  (v31/*: any*/),
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "projectKey"
  }
],
v34 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  }
],
v35 = {
  "kind": "Variable",
  "name": "issueSearchInput",
  "variableName": "issueSearchInput"
},
v36 = {
  "kind": "Variable",
  "name": "scope",
  "variableName": "scope"
},
v37 = {
  "kind": "Variable",
  "name": "settings",
  "variableName": "settings"
},
v38 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v39 = {
  "kind": "ScalarField",
  "name": "message"
},
v40 = [
  {
    "kind": "LinkedField",
    "name": "extensions",
    "plural": true,
    "selections": [
      (v38/*: any*/),
      {
        "kind": "ScalarField",
        "name": "statusCode"
      }
    ]
  },
  (v39/*: any*/)
],
v41 = {
  "kind": "ScalarField",
  "name": "id"
},
v42 = {
  "kind": "Variable",
  "name": "scope",
  "variableName": "fieldSetsScope"
},
v43 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "fieldSetSelectedState": "SELECTED"
    }
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "amountOfColumns"
  },
  (v42/*: any*/)
],
v44 = {
  "kind": "ScalarField",
  "name": "fieldSetId"
},
v45 = {
  "kind": "ScalarField",
  "name": "jql"
},
v46 = {
  "kind": "ScalarField",
  "name": "savedViewId"
},
v47 = {
  "args": [
    (v37/*: any*/)
  ],
  "kind": "ScalarField",
  "name": "isViewConfigModified"
},
v48 = {
  "kind": "Variable",
  "name": "groupBy",
  "variableName": "groupBy"
},
v49 = [
  (v48/*: any*/),
  (v35/*: any*/),
  (v37/*: any*/),
  {
    "kind": "Variable",
    "name": "staticViewInput",
    "variableName": "staticViewInput"
  }
],
v50 = {
  "kind": "ScalarField",
  "name": "fieldId"
},
v51 = {
  "concreteType": "JiraSpreadsheetGroupByConfig",
  "kind": "LinkedField",
  "name": "groupByConfig",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraField",
      "kind": "LinkedField",
      "name": "groupByField",
      "plural": false,
      "selections": [
        (v50/*: any*/),
        (v41/*: any*/)
      ]
    }
  ]
},
v52 = {
  "kind": "ScalarField",
  "name": "hideDone"
},
v53 = {
  "kind": "ScalarField",
  "name": "isHierarchyEnabled"
},
v54 = {
  "kind": "ScalarField",
  "name": "__id"
},
v55 = {
  "kind": "ClientExtension",
  "selections": [
    (v54/*: any*/)
  ]
},
v56 = {
  "kind": "ScalarField",
  "name": "isGroupingEnabled"
},
v57 = {
  "kind": "ScalarField",
  "name": "canEnableGrouping"
},
v58 = {
  "kind": "ScalarField",
  "name": "totalCount"
},
v59 = {
  "kind": "ScalarField",
  "name": "type"
},
v60 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v61 = {
  "kind": "ScalarField",
  "name": "jqlTerm"
},
v62 = {
  "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "aliases"
    }
  ]
},
v63 = {
  "kind": "ScalarField",
  "name": "canEnableHierarchy"
},
v64 = {
  "kind": "ScalarField",
  "name": "value"
},
v65 = {
  "kind": "InlineFragment",
  "selections": [
    (v50/*: any*/),
    {
      "alias": "singleValueOperator",
      "kind": "ScalarField",
      "name": "operator"
    },
    (v64/*: any*/)
  ],
  "type": "JiraFormattingSingleValueOperand"
},
v66 = {
  "kind": "InlineFragment",
  "selections": [
    (v50/*: any*/),
    {
      "alias": "multipleValueOperator",
      "kind": "ScalarField",
      "name": "operator"
    },
    {
      "kind": "ScalarField",
      "name": "values"
    }
  ],
  "type": "JiraFormattingMultipleValueOperand"
},
v67 = {
  "kind": "InlineFragment",
  "selections": [
    (v50/*: any*/),
    {
      "alias": "noValueOperator",
      "kind": "ScalarField",
      "name": "operator"
    }
  ],
  "type": "JiraFormattingNoValueOperand"
},
v68 = {
  "kind": "LinkedField",
  "name": "expression",
  "plural": false,
  "selections": [
    (v38/*: any*/),
    (v65/*: any*/),
    (v66/*: any*/),
    (v67/*: any*/)
  ]
},
v69 = {
  "kind": "ScalarField",
  "name": "formattingArea"
},
v70 = {
  "kind": "ScalarField",
  "name": "colorKey"
},
v71 = [
  {
    "concreteType": "JiraFormattingRuleEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "JiraFormattingRule",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v68/*: any*/),
          (v69/*: any*/),
          {
            "concreteType": "JiraColor",
            "kind": "LinkedField",
            "name": "formattingColor",
            "plural": false,
            "selections": [
              (v41/*: any*/),
              (v70/*: any*/)
            ]
          },
          (v41/*: any*/)
        ]
      }
    ]
  }
],
v72 = {
  "kind": "ScalarField",
  "name": "name"
},
v73 = [
  (v70/*: any*/),
  (v41/*: any*/)
],
v74 = {
  "concreteType": "JiraColor",
  "kind": "LinkedField",
  "name": "formattingColor",
  "plural": false,
  "selections": (v73/*: any*/)
},
v75 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v76 = {
  "kind": "Variable",
  "name": "before",
  "variableName": "before"
},
v77 = {
  "kind": "Variable",
  "name": "fieldSetsInput",
  "variableName": "fieldSetsInput"
},
v78 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v79 = {
  "kind": "Variable",
  "name": "last",
  "variableName": "last"
},
v80 = {
  "kind": "Variable",
  "name": "options",
  "variableName": "options"
},
v81 = {
  "kind": "Variable",
  "name": "saveJQLToUserHistory",
  "variableName": "saveJQLToUserHistory"
},
v82 = [
  (v75/*: any*/),
  (v76/*: any*/),
  (v77/*: any*/),
  (v78/*: any*/),
  (v35/*: any*/),
  (v79/*: any*/),
  (v80/*: any*/),
  (v81/*: any*/),
  (v36/*: any*/),
  (v37/*: any*/)
],
v83 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v84 = {
  "kind": "ScalarField",
  "name": "key"
},
v85 = {
  "kind": "ScalarField",
  "name": "issueId"
},
v86 = {
  "concreteType": "JiraIssueTypeHierarchyLevel",
  "kind": "LinkedField",
  "name": "hierarchy",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "level"
    }
  ]
},
v87 = {
  "concreteType": "JiraIssueTypeField",
  "kind": "LinkedField",
  "name": "issueTypeField",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraIssueType",
      "kind": "LinkedField",
      "name": "issueType",
      "plural": false,
      "selections": [
        (v86/*: any*/),
        (v41/*: any*/)
      ]
    },
    (v41/*: any*/)
  ]
},
v88 = {
  "kind": "ScalarField",
  "name": "isResolved"
},
v89 = {
  "kind": "ScalarField",
  "name": "statusCategoryId"
},
v90 = {
  "concreteType": "JiraStatusCategory",
  "kind": "LinkedField",
  "name": "statusCategory",
  "plural": false,
  "selections": [
    (v89/*: any*/),
    (v41/*: any*/)
  ]
},
v91 = {
  "concreteType": "JiraStatus",
  "kind": "LinkedField",
  "name": "status",
  "plural": false,
  "selections": [
    (v90/*: any*/),
    (v41/*: any*/)
  ]
},
v92 = {
  "concreteType": "JiraStatusField",
  "kind": "LinkedField",
  "name": "statusField",
  "plural": false,
  "selections": [
    (v91/*: any*/),
    (v41/*: any*/)
  ]
},
v93 = [
  (v72/*: any*/)
],
v94 = {
  "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "concreteType": "JiraIssueTypeField",
      "kind": "LinkedField",
      "name": "issueTypeField",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraIssueType",
          "kind": "LinkedField",
          "name": "issueType",
          "plural": false,
          "selections": (v93/*: any*/)
        }
      ]
    }
  ]
},
v95 = {
  "kind": "ClientExtension",
  "selections": [
    (v54/*: any*/),
    {
      "kind": "ScalarField",
      "name": "isHighlightedIssueRow"
    }
  ]
},
v96 = {
  "kind": "ScalarField",
  "name": "summary"
},
v97 = {
  "concreteType": "JiraAvatar",
  "kind": "LinkedField",
  "name": "avatar",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "small"
    }
  ]
},
v98 = {
  "concreteType": "JiraIssue",
  "kind": "LinkedField",
  "name": "node",
  "plural": false,
  "selections": [
    (v38/*: any*/),
    (v41/*: any*/),
    (v84/*: any*/),
    (v85/*: any*/),
    (v87/*: any*/),
    (v88/*: any*/),
    (v92/*: any*/),
    (v94/*: any*/),
    (v95/*: any*/),
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        (v96/*: any*/),
        {
          "concreteType": "JiraIssueTypeField",
          "kind": "LinkedField",
          "name": "issueTypeField",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraIssueType",
              "kind": "LinkedField",
              "name": "issueType",
              "plural": false,
              "selections": [
                (v97/*: any*/),
                {
                  "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": (v93/*: any*/)
                }
              ]
            }
          ]
        }
      ]
    }
  ]
},
v99 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 500
  }
],
v100 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isJiraIssueField"
},
v101 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraAffectedServiceConnection",
      "kind": "LinkedField",
      "name": "selectedAffectedServicesConnection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraAffectedServiceEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraAffectedService",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "serviceId"
                },
                (v72/*: any*/),
                (v41/*: any*/)
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraAffectedServicesField"
},
v102 = [
  (v64/*: any*/),
  (v41/*: any*/),
  {
    "kind": "ScalarField",
    "name": "isDisabled"
  }
],
v103 = {
  "kind": "ScalarField",
  "name": "lazyIsEditableInIssueView"
},
v104 = {
  "kind": "ClientExtension",
  "selections": [
    (v103/*: any*/)
  ]
},
v105 = {
  "kind": "InlineFragment",
  "selections": [
    (v72/*: any*/),
    {
      "concreteType": "JiraCascadingOption",
      "kind": "LinkedField",
      "name": "cascadingOption",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraOption",
          "kind": "LinkedField",
          "name": "parentOptionValue",
          "plural": false,
          "selections": (v102/*: any*/)
        },
        {
          "concreteType": "JiraOption",
          "kind": "LinkedField",
          "name": "childOptionValue",
          "plural": false,
          "selections": (v102/*: any*/)
        }
      ]
    },
    (v104/*: any*/)
  ],
  "type": "JiraCascadingSelectField"
},
v106 = [
  (v39/*: any*/)
],
v107 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraCmdbObjectConnection",
      "kind": "LinkedField",
      "name": "selectedCmdbObjectsConnection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraCmdbObjectEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraCmdbObject",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "objectId"
                },
                {
                  "kind": "ScalarField",
                  "name": "label"
                },
                {
                  "concreteType": "JiraCmdbAvatar",
                  "kind": "LinkedField",
                  "name": "avatar",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "JiraCmdbMediaClientConfig",
                      "kind": "LinkedField",
                      "name": "mediaClientConfig",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "name": "clientId"
                        },
                        {
                          "kind": "ScalarField",
                          "name": "fileId"
                        },
                        {
                          "kind": "ScalarField",
                          "name": "mediaBaseUrl"
                        },
                        {
                          "kind": "ScalarField",
                          "name": "mediaJwtToken"
                        }
                      ]
                    },
                    {
                      "kind": "ScalarField",
                      "name": "url48"
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          "concreteType": "QueryError",
          "kind": "LinkedField",
          "name": "errors",
          "plural": true,
          "selections": (v106/*: any*/)
        }
      ]
    }
  ],
  "type": "JiraCMDBField"
},
v108 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  }
],
v109 = {
  "alias": "value",
  "kind": "ScalarField",
  "name": "id"
},
v110 = {
  "alias": "label",
  "kind": "ScalarField",
  "name": "name"
},
v111 = {
  "kind": "InlineFragment",
  "selections": [
    (v72/*: any*/),
    {
      "args": (v108/*: any*/),
      "concreteType": "JiraComponentConnection",
      "kind": "LinkedField",
      "name": "selectedComponentsConnection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraComponentEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraComponent",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v109/*: any*/),
                (v110/*: any*/),
                (v41/*: any*/)
              ]
            }
          ]
        }
      ],
      "storageKey": "selectedComponentsConnection(first:1000)"
    },
    (v104/*: any*/)
  ],
  "type": "JiraComponentsField"
},
v112 = {
  "kind": "ScalarField",
  "name": "date"
},
v113 = {
  "concreteType": "JiraFieldConfig",
  "kind": "LinkedField",
  "name": "fieldConfig",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isRequired"
    }
  ]
},
v114 = {
  "kind": "InlineFragment",
  "selections": [
    (v112/*: any*/),
    (v72/*: any*/),
    (v113/*: any*/),
    (v104/*: any*/)
  ],
  "type": "JiraDatePickerField"
},
v115 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "dateTime"
    },
    (v72/*: any*/),
    (v104/*: any*/)
  ],
  "type": "JiraDateTimePickerField"
},
v116 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraEpic",
      "kind": "LinkedField",
      "name": "epic",
      "plural": false,
      "selections": [
        (v84/*: any*/),
        (v96/*: any*/),
        {
          "kind": "ScalarField",
          "name": "color"
        },
        (v41/*: any*/)
      ]
    }
  ],
  "type": "JiraEpicLinkField"
},
v117 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "renderedFieldHtml"
    }
  ],
  "type": "JiraFallbackField"
},
v118 = {
  "kind": "ScalarField",
  "name": "text"
},
v119 = {
  "kind": "InlineFragment",
  "selections": [
    (v118/*: any*/),
    (v72/*: any*/),
    (v104/*: any*/)
  ],
  "type": "JiraSingleLineTextField"
},
v120 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraStatusCategory",
      "kind": "LinkedField",
      "name": "statusCategory",
      "plural": false,
      "selections": [
        (v72/*: any*/),
        (v89/*: any*/),
        (v41/*: any*/)
      ]
    }
  ],
  "type": "JiraStatusCategoryField"
},
v121 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraStatus",
      "kind": "LinkedField",
      "name": "status",
      "plural": false,
      "selections": [
        (v72/*: any*/),
        {
          "kind": "ScalarField",
          "name": "statusId"
        },
        (v90/*: any*/),
        (v41/*: any*/)
      ]
    }
  ],
  "type": "JiraStatusField"
},
v122 = {
  "concreteType": "JiraColor",
  "kind": "LinkedField",
  "name": "color",
  "plural": false,
  "selections": (v73/*: any*/)
},
v123 = [
  (v72/*: any*/),
  (v122/*: any*/)
],
v124 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "args": (v108/*: any*/),
      "concreteType": "JiraLabelConnection",
      "kind": "LinkedField",
      "name": "selectedLabelsConnection",
      "plural": false,
      "selections": [
        (v58/*: any*/),
        {
          "concreteType": "JiraLabelEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraLabel",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": (v123/*: any*/)
            }
          ]
        }
      ],
      "storageKey": "selectedLabelsConnection(first:1000)"
    },
    (v72/*: any*/),
    (v104/*: any*/)
  ],
  "type": "JiraLabelsField"
},
v125 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraIssueType",
      "kind": "LinkedField",
      "name": "issueType",
      "plural": false,
      "selections": [
        (v97/*: any*/),
        (v72/*: any*/),
        (v41/*: any*/)
      ]
    }
  ],
  "type": "JiraIssueTypeField"
},
v126 = {
  "concreteType": "JiraAvatar",
  "kind": "LinkedField",
  "name": "avatar",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "xsmall"
    }
  ]
},
v127 = {
  "kind": "ScalarField",
  "name": "webUrl"
},
v128 = {
  "kind": "ScalarField",
  "name": "issueTypeId"
},
v129 = {
  "concreteType": "JiraStatusCategory",
  "kind": "LinkedField",
  "name": "statusCategory",
  "plural": false,
  "selections": [
    (v41/*: any*/),
    (v89/*: any*/)
  ]
},
v130 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraIssue",
      "kind": "LinkedField",
      "name": "parentIssue",
      "plural": false,
      "selections": [
        (v84/*: any*/),
        {
          "concreteType": "JiraColorField",
          "kind": "LinkedField",
          "name": "issueColorField",
          "plural": false,
          "selections": [
            (v122/*: any*/),
            (v41/*: any*/)
          ]
        },
        {
          "concreteType": "JiraIssueTypeField",
          "kind": "LinkedField",
          "name": "issueTypeField",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraIssueType",
              "kind": "LinkedField",
              "name": "issueType",
              "plural": false,
              "selections": [
                (v126/*: any*/),
                (v72/*: any*/),
                (v41/*: any*/)
              ]
            },
            (v41/*: any*/)
          ]
        },
        {
          "concreteType": "JiraSingleLineTextField",
          "kind": "LinkedField",
          "name": "summaryField",
          "plural": false,
          "selections": [
            (v118/*: any*/),
            (v41/*: any*/)
          ]
        },
        (v41/*: any*/),
        (v85/*: any*/),
        (v127/*: any*/),
        {
          "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
          "kind": "Condition",
          "passingValue": false,
          "selections": [
            {
              "args": [
                {
                  "kind": "Literal",
                  "name": "ids",
                  "value": [
                    "issuetype",
                    "project",
                    "summary",
                    "status"
                  ]
                }
              ],
              "concreteType": "JiraIssueFieldConnection",
              "kind": "LinkedField",
              "name": "fieldsById",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JiraIssueFieldEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        (v38/*: any*/),
                        (v41/*: any*/),
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            (v50/*: any*/),
                            (v118/*: any*/)
                          ],
                          "type": "JiraSingleLineTextField"
                        },
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            (v50/*: any*/),
                            {
                              "concreteType": "JiraIssueType",
                              "kind": "LinkedField",
                              "name": "issueType",
                              "plural": false,
                              "selections": [
                                (v41/*: any*/),
                                (v128/*: any*/),
                                (v72/*: any*/),
                                (v126/*: any*/),
                                (v86/*: any*/)
                              ]
                            }
                          ],
                          "type": "JiraIssueTypeField"
                        },
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            (v50/*: any*/),
                            {
                              "concreteType": "JiraStatus",
                              "kind": "LinkedField",
                              "name": "status",
                              "plural": false,
                              "selections": [
                                (v41/*: any*/),
                                (v129/*: any*/)
                              ]
                            }
                          ],
                          "type": "JiraStatusField"
                        }
                      ]
                    }
                  ]
                }
              ],
              "storageKey": "fieldsById(ids:[\"issuetype\",\"project\",\"summary\",\"status\"])"
            }
          ]
        },
        {
          "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "concreteType": "JiraIssueTypeField",
              "kind": "LinkedField",
              "name": "issueTypeField",
              "plural": false,
              "selections": [
                (v50/*: any*/),
                {
                  "concreteType": "JiraIssueType",
                  "kind": "LinkedField",
                  "name": "issueType",
                  "plural": false,
                  "selections": [
                    (v128/*: any*/),
                    (v86/*: any*/)
                  ]
                }
              ]
            },
            {
              "concreteType": "JiraSingleLineTextField",
              "kind": "LinkedField",
              "name": "summaryField",
              "plural": false,
              "selections": [
                (v50/*: any*/)
              ]
            },
            {
              "concreteType": "JiraStatusField",
              "kind": "LinkedField",
              "name": "statusField",
              "plural": false,
              "selections": [
                (v41/*: any*/),
                (v50/*: any*/),
                (v91/*: any*/)
              ]
            }
          ]
        }
      ]
    },
    (v72/*: any*/),
    (v104/*: any*/)
  ],
  "type": "JiraParentIssueField"
},
v131 = {
  "kind": "ScalarField",
  "name": "iconUrl"
},
v132 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraPriority",
      "kind": "LinkedField",
      "name": "priority",
      "plural": false,
      "selections": [
        (v72/*: any*/),
        (v131/*: any*/),
        (v41/*: any*/)
      ]
    },
    (v72/*: any*/),
    (v104/*: any*/)
  ],
  "type": "JiraPriorityField"
},
v133 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraProject",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        (v72/*: any*/),
        (v84/*: any*/),
        {
          "concreteType": "JiraAvatar",
          "kind": "LinkedField",
          "name": "avatar",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "large"
            }
          ]
        },
        (v41/*: any*/)
      ]
    }
  ],
  "type": "JiraProjectField"
},
v134 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraResolution",
      "kind": "LinkedField",
      "name": "resolution",
      "plural": false,
      "selections": [
        (v72/*: any*/),
        (v41/*: any*/)
      ]
    }
  ],
  "type": "JiraResolutionField"
},
v135 = [
  (v41/*: any*/),
  {
    "kind": "ScalarField",
    "name": "sprintId"
  },
  (v72/*: any*/),
  {
    "kind": "ScalarField",
    "name": "state"
  },
  {
    "kind": "ScalarField",
    "name": "endDate"
  }
],
v136 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraSprintConnection",
      "kind": "LinkedField",
      "name": "selectedSprintsConnection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraSprintEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraSprint",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": (v135/*: any*/)
            }
          ]
        }
      ]
    },
    (v72/*: any*/),
    (v104/*: any*/)
  ],
  "type": "JiraSprintField"
},
v137 = {
  "kind": "ScalarField",
  "name": "picture"
},
v138 = {
  "kind": "ScalarField",
  "name": "accountStatus"
},
v139 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v140 = [
  {
    "kind": "ScalarField",
    "name": "appType"
  }
],
v141 = [
  {
    "kind": "TypeDiscriminator",
    "abstractKey": "__isUser"
  },
  {
    "kind": "InlineFragment",
    "selections": (v140/*: any*/),
    "type": "AppUser"
  }
],
v142 = {
  "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider",
  "kind": "Condition",
  "passingValue": true,
  "selections": (v141/*: any*/)
},
v143 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaifetchapptypeforuserassigneerelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": (v140/*: any*/)
    }
  ],
  "type": "AppUser"
},
v144 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraRichText",
      "kind": "LinkedField",
      "name": "richText",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraADF",
          "kind": "LinkedField",
          "name": "adfValue",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraAdfToConvertedPlainText",
              "kind": "LinkedField",
              "name": "convertedPlainText",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "plainText"
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraRichTextField"
},
v145 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraServiceManagementRequestType",
      "kind": "LinkedField",
      "name": "requestType",
      "plural": false,
      "selections": [
        (v72/*: any*/),
        (v126/*: any*/),
        (v41/*: any*/)
      ]
    }
  ],
  "type": "JiraServiceManagementRequestTypeField"
},
v146 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 1
        }
      ],
      "concreteType": "JiraIssueLinkConnection",
      "kind": "LinkedField",
      "name": "issueLinkConnection",
      "plural": false,
      "selections": [
        (v58/*: any*/),
        {
          "concreteType": "JiraIssueLinkEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraIssueLink",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JiraIssue",
                  "kind": "LinkedField",
                  "name": "issue",
                  "plural": false,
                  "selections": [
                    (v127/*: any*/),
                    (v84/*: any*/),
                    {
                      "args": [
                        {
                          "kind": "Literal",
                          "name": "ids",
                          "value": [
                            "statusCategory"
                          ]
                        }
                      ],
                      "concreteType": "JiraIssueFieldConnection",
                      "kind": "LinkedField",
                      "name": "fieldsById",
                      "plural": false,
                      "selections": [
                        {
                          "concreteType": "JiraIssueFieldEdge",
                          "kind": "LinkedField",
                          "name": "edges",
                          "plural": true,
                          "selections": [
                            {
                              "kind": "LinkedField",
                              "name": "node",
                              "plural": false,
                              "selections": [
                                (v38/*: any*/),
                                {
                                  "kind": "InlineFragment",
                                  "selections": [
                                    (v90/*: any*/)
                                  ],
                                  "type": "JiraStatusCategoryField"
                                },
                                (v41/*: any*/)
                              ]
                            }
                          ]
                        }
                      ],
                      "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                    },
                    {
                      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider",
                      "kind": "Condition",
                      "passingValue": true,
                      "selections": [
                        (v88/*: any*/)
                      ]
                    },
                    (v41/*: any*/)
                  ]
                },
                {
                  "kind": "ScalarField",
                  "name": "relationName"
                },
                (v41/*: any*/)
              ]
            }
          ]
        }
      ],
      "storageKey": "issueLinkConnection(first:1)"
    }
  ],
  "type": "JiraIssueLinkField"
},
v147 = {
  "kind": "ScalarField",
  "name": "number"
},
v148 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isStoryPointField"
    },
    (v147/*: any*/),
    (v72/*: any*/),
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "concreteType": "JiraNumberFieldFormatConfig",
          "kind": "LinkedField",
          "name": "formatConfig",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "formatStyle"
            },
            {
              "kind": "ScalarField",
              "name": "formatUnit"
            }
          ]
        }
      ]
    },
    (v104/*: any*/)
  ],
  "type": "JiraNumberField"
},
v149 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraCommentSummary",
      "kind": "LinkedField",
      "name": "commentSummary",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "canAddComment"
        },
        (v58/*: any*/)
      ]
    }
  ],
  "type": "JiraCommentSummaryField"
},
v150 = {
  "kind": "InlineFragment",
  "selections": [
    (v72/*: any*/),
    {
      "kind": "ScalarField",
      "name": "uri"
    },
    (v104/*: any*/)
  ],
  "type": "JiraUrlField"
},
v151 = {
  "kind": "ScalarField",
  "name": "optionId"
},
v152 = {
  "kind": "InlineFragment",
  "selections": [
    (v72/*: any*/),
    {
      "concreteType": "JiraOption",
      "kind": "LinkedField",
      "name": "fieldOption",
      "plural": false,
      "selections": [
        (v64/*: any*/),
        (v122/*: any*/),
        (v41/*: any*/),
        (v151/*: any*/)
      ]
    },
    (v104/*: any*/)
  ],
  "type": "JiraSingleSelectField"
},
v153 = {
  "kind": "InlineFragment",
  "selections": [
    (v72/*: any*/),
    {
      "concreteType": "JiraOptionConnection",
      "kind": "LinkedField",
      "name": "selectedOptions",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraOptionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraOption",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v41/*: any*/),
                (v64/*: any*/),
                (v151/*: any*/)
              ]
            }
          ]
        }
      ]
    },
    (v104/*: any*/)
  ],
  "type": "JiraMultipleSelectField"
},
v154 = {
  "concreteType": "JiraOption",
  "kind": "LinkedField",
  "name": "node",
  "plural": false,
  "selections": [
    (v41/*: any*/),
    (v64/*: any*/)
  ]
},
v155 = {
  "kind": "InlineFragment",
  "selections": [
    (v72/*: any*/),
    {
      "concreteType": "JiraUserConnection",
      "kind": "LinkedField",
      "name": "selectedUsersConnection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraUserEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v38/*: any*/),
                (v139/*: any*/),
                (v72/*: any*/),
                (v137/*: any*/),
                (v41/*: any*/),
                (v138/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "email"
                    }
                  ],
                  "type": "AtlassianAccountUser"
                }
              ]
            }
          ]
        }
      ]
    },
    (v104/*: any*/)
  ],
  "type": "JiraMultipleSelectUserPickerField"
},
v156 = {
  "kind": "InlineFragment",
  "selections": [
    (v72/*: any*/),
    {
      "concreteType": "JiraTeamView",
      "kind": "LinkedField",
      "name": "selectedTeam",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "jiraSuppliedId"
        },
        {
          "kind": "ScalarField",
          "name": "jiraSuppliedName"
        }
      ]
    },
    (v104/*: any*/)
  ],
  "type": "JiraTeamViewField"
},
v157 = {
  "concreteType": "JiraEstimate",
  "kind": "LinkedField",
  "name": "originalEstimate",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "timeInSeconds"
    }
  ]
},
v158 = {
  "concreteType": "JiraTimeTrackingSettings",
  "kind": "LinkedField",
  "name": "timeTrackingSettings",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "workingHoursPerDay"
    },
    {
      "kind": "ScalarField",
      "name": "workingDaysPerWeek"
    },
    {
      "kind": "ScalarField",
      "name": "defaultFormat"
    },
    {
      "kind": "ScalarField",
      "name": "defaultUnit"
    }
  ]
},
v159 = {
  "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider",
  "kind": "Condition",
  "passingValue": false,
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraIssue",
          "kind": "LinkedField",
          "name": "issue",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraTimeTrackingField",
              "kind": "LinkedField",
              "name": "timeTrackingField",
              "plural": false,
              "selections": [
                (v41/*: any*/),
                (v157/*: any*/),
                (v158/*: any*/),
                (v50/*: any*/),
                (v72/*: any*/),
                (v59/*: any*/),
                (v104/*: any*/)
              ]
            },
            (v41/*: any*/)
          ]
        }
      ],
      "type": "JiraOriginalTimeEstimateField"
    }
  ]
},
v160 = {
  "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraIssue",
          "kind": "LinkedField",
          "name": "issue",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraTimeTrackingField",
              "kind": "LinkedField",
              "name": "timeTrackingField",
              "plural": false,
              "selections": [
                (v157/*: any*/),
                (v158/*: any*/),
                (v41/*: any*/),
                (v50/*: any*/),
                (v72/*: any*/),
                (v59/*: any*/)
              ]
            },
            (v41/*: any*/)
          ]
        },
        (v104/*: any*/)
      ],
      "type": "JiraOriginalTimeEstimateField"
    }
  ]
},
v161 = {
  "kind": "InlineFragment",
  "selections": [
    (v72/*: any*/),
    {
      "concreteType": "JiraOption",
      "kind": "LinkedField",
      "name": "selectedOption",
      "plural": false,
      "selections": [
        {
          "alias": "label",
          "kind": "ScalarField",
          "name": "value"
        },
        (v41/*: any*/),
        (v109/*: any*/)
      ]
    },
    (v104/*: any*/)
  ],
  "type": "JiraRadioSelectField"
},
v162 = {
  "kind": "ScalarField",
  "name": "versionId"
},
v163 = {
  "kind": "InlineFragment",
  "selections": [
    (v72/*: any*/),
    {
      "args": (v108/*: any*/),
      "concreteType": "JiraVersionConnection",
      "kind": "LinkedField",
      "name": "selectedVersionsConnection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraVersionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraVersion",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v41/*: any*/),
                (v72/*: any*/),
                (v109/*: any*/),
                (v110/*: any*/),
                (v162/*: any*/)
              ]
            }
          ]
        }
      ],
      "storageKey": "selectedVersionsConnection(first:1000)"
    },
    (v104/*: any*/)
  ],
  "type": "JiraMultipleVersionPickerField"
},
v164 = [
  (v41/*: any*/)
],
v165 = {
  "concreteType": "JiraIssue",
  "kind": "LinkedField",
  "name": "issue",
  "plural": false,
  "selections": (v164/*: any*/)
},
v166 = {
  "kind": "ScalarField",
  "name": "status"
},
v167 = {
  "kind": "InlineFragment",
  "selections": [
    (v72/*: any*/),
    (v165/*: any*/),
    {
      "args": (v108/*: any*/),
      "concreteType": "JiraGoalConnection",
      "kind": "LinkedField",
      "name": "selectedGoals",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraGoalEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraGoal",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v41/*: any*/),
                (v84/*: any*/),
                {
                  "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    (v72/*: any*/),
                    (v166/*: any*/)
                  ]
                }
              ]
            }
          ]
        },
        (v55/*: any*/)
      ],
      "storageKey": "selectedGoals(first:1000)"
    },
    {
      "kind": "ClientExtension",
      "selections": [
        (v54/*: any*/),
        (v103/*: any*/)
      ]
    }
  ],
  "type": "JiraGoalsField"
},
v168 = {
  "kind": "ScalarField",
  "name": "privateProject"
},
v169 = {
  "kind": "ScalarField",
  "name": "hasPermission"
},
v170 = {
  "kind": "ScalarField",
  "name": "iconName"
},
v171 = {
  "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        (v72/*: any*/),
        (v165/*: any*/),
        {
          "kind": "ScalarField",
          "name": "isLinkEditable"
        },
        {
          "concreteType": "JiraTownsquareProject",
          "kind": "LinkedField",
          "name": "project",
          "plural": false,
          "selections": [
            (v41/*: any*/),
            {
              "alias": "atlasProjectName",
              "kind": "ScalarField",
              "name": "name"
            },
            {
              "alias": "atlasProjectKey",
              "kind": "ScalarField",
              "name": "key"
            },
            (v168/*: any*/),
            (v169/*: any*/),
            {
              "kind": "ScalarField",
              "name": "isWorkspaceActive"
            },
            (v170/*: any*/)
          ]
        },
        (v104/*: any*/)
      ],
      "type": "JiraTownsquareProjectField"
    }
  ]
},
v172 = {
  "kind": "ScalarField",
  "name": "href"
},
v173 = {
  "kind": "InlineFragment",
  "selections": [
    (v72/*: any*/),
    {
      "args": (v108/*: any*/),
      "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
      "kind": "LinkedField",
      "name": "confluenceRemoteIssueLinks",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraConfluenceRemoteIssueLink",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v41/*: any*/),
                (v172/*: any*/),
                {
                  "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "name": "pageContent",
                      "plural": false,
                      "selections": [
                        (v38/*: any*/),
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            (v172/*: any*/)
                          ],
                          "type": "JiraConfluencePageContentDetails"
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        },
        (v58/*: any*/)
      ],
      "storageKey": "confluenceRemoteIssueLinks(first:1000)"
    },
    (v104/*: any*/)
  ],
  "type": "JiraConfluenceRemoteIssueLinksField"
},
v174 = {
  "kind": "ScalarField",
  "name": "groupId"
},
v175 = {
  "kind": "InlineFragment",
  "selections": [
    (v72/*: any*/),
    {
      "concreteType": "JiraGroupConnection",
      "kind": "LinkedField",
      "name": "selectedGroupsConnection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraGroupEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraGroup",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v41/*: any*/),
                (v72/*: any*/),
                (v174/*: any*/)
              ]
            }
          ]
        }
      ]
    },
    (v104/*: any*/)
  ],
  "type": "JiraMultipleGroupPickerField"
},
v176 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraFlag",
      "kind": "LinkedField",
      "name": "flag",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isFlagged"
        }
      ]
    }
  ],
  "type": "JiraFlagField"
},
v177 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraWatch",
      "kind": "LinkedField",
      "name": "watch",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "count"
        },
        {
          "kind": "ScalarField",
          "name": "isWatching"
        }
      ]
    }
  ],
  "type": "JiraWatchesField"
},
v178 = [
  {
    "kind": "Literal",
    "name": "viewId",
    "value": "list_default"
  }
],
v179 = {
  "kind": "InlineFragment",
  "selections": [
    (v112/*: any*/)
  ],
  "type": "JiraDatePickerField"
},
v180 = [
  (v38/*: any*/),
  (v50/*: any*/),
  (v179/*: any*/),
  (v41/*: any*/)
],
v181 = [
  (v38/*: any*/),
  (v179/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": (v164/*: any*/),
    "type": "Node",
    "abstractKey": "__isNode"
  }
],
v182 = {
  "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "concreteType": "JiraIssue",
              "kind": "LinkedField",
              "name": "issue",
              "plural": false,
              "selections": [
                (v41/*: any*/),
                (v85/*: any*/),
                {
                  "concreteType": "JiraIssueTypeField",
                  "kind": "LinkedField",
                  "name": "issueTypeField",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "JiraIssueType",
                      "kind": "LinkedField",
                      "name": "issueType",
                      "plural": false,
                      "selections": [
                        (v72/*: any*/),
                        (v86/*: any*/),
                        (v41/*: any*/)
                      ]
                    },
                    (v41/*: any*/)
                  ]
                },
                {
                  "concreteType": "JiraParentIssueField",
                  "kind": "LinkedField",
                  "name": "parentIssueField",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "JiraIssue",
                      "kind": "LinkedField",
                      "name": "parentIssue",
                      "plural": false,
                      "selections": [
                        (v85/*: any*/),
                        (v84/*: any*/),
                        (v41/*: any*/)
                      ]
                    },
                    (v41/*: any*/)
                  ]
                },
                (v84/*: any*/),
                (v92/*: any*/),
                {
                  "concreteType": "JiraSingleSelectUserPickerField",
                  "kind": "LinkedField",
                  "name": "assigneeField",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "name": "user",
                      "plural": false,
                      "selections": [
                        (v38/*: any*/),
                        (v137/*: any*/),
                        (v41/*: any*/)
                      ]
                    },
                    (v41/*: any*/)
                  ]
                },
                {
                  "args": (v178/*: any*/),
                  "kind": "LinkedField",
                  "name": "startDateViewField",
                  "plural": false,
                  "selections": (v180/*: any*/),
                  "storageKey": "startDateViewField(viewId:\"list_default\")"
                },
                {
                  "args": (v178/*: any*/),
                  "kind": "LinkedField",
                  "name": "endDateViewField",
                  "plural": false,
                  "selections": (v180/*: any*/),
                  "storageKey": "endDateViewField(viewId:\"list_default\")"
                }
              ]
            },
            {
              "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "name": "aggregatedStartDateViewField",
                      "plural": false,
                      "selections": (v181/*: any*/)
                    },
                    {
                      "kind": "LinkedField",
                      "name": "aggregatedEndDateViewField",
                      "plural": false,
                      "selections": (v181/*: any*/)
                    }
                  ],
                  "type": "JiraAggregatedTimelineField"
                }
              ]
            }
          ],
          "type": "JiraTimelineVirtualField",
          "abstractKey": "__isJiraTimelineVirtualField"
        }
      ],
      "type": "JiraAggregatedTimelineField"
    }
  ]
},
v183 = {
  "kind": "ScalarField",
  "name": "priorityId"
},
v184 = {
  "kind": "ScalarField",
  "name": "projectId"
},
v185 = [
  (v38/*: any*/),
  (v41/*: any*/)
],
v186 = {
  "args": (v99/*: any*/),
  "concreteType": "JiraIssueFieldSetConnection",
  "kind": "LinkedField",
  "name": "fieldSets",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraIssueFieldSetEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "JiraIssueFieldSet",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v59/*: any*/),
            (v44/*: any*/),
            {
              "concreteType": "JiraIssueFieldConnection",
              "kind": "LinkedField",
              "name": "fields",
              "plural": false,
              "selections": [
                (v58/*: any*/),
                {
                  "concreteType": "JiraIssueFieldEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        (v41/*: any*/),
                        (v38/*: any*/),
                        (v50/*: any*/),
                        (v59/*: any*/),
                        (v100/*: any*/),
                        (v101/*: any*/),
                        (v105/*: any*/),
                        (v107/*: any*/),
                        (v111/*: any*/),
                        (v114/*: any*/),
                        (v115/*: any*/),
                        (v116/*: any*/),
                        (v117/*: any*/),
                        (v119/*: any*/),
                        (v120/*: any*/),
                        (v121/*: any*/),
                        (v124/*: any*/),
                        (v125/*: any*/),
                        (v130/*: any*/),
                        (v132/*: any*/),
                        (v133/*: any*/),
                        (v134/*: any*/),
                        (v136/*: any*/),
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            (v72/*: any*/),
                            {
                              "kind": "LinkedField",
                              "name": "user",
                              "plural": false,
                              "selections": [
                                (v38/*: any*/),
                                (v72/*: any*/),
                                (v137/*: any*/),
                                (v138/*: any*/),
                                (v41/*: any*/),
                                (v139/*: any*/),
                                (v142/*: any*/),
                                (v143/*: any*/),
                                {
                                  "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerninrelayprovider",
                                  "kind": "Condition",
                                  "passingValue": true,
                                  "selections": (v141/*: any*/)
                                }
                              ]
                            },
                            (v113/*: any*/),
                            (v104/*: any*/)
                          ],
                          "type": "JiraSingleSelectUserPickerField"
                        },
                        (v144/*: any*/),
                        (v145/*: any*/),
                        (v146/*: any*/),
                        (v148/*: any*/),
                        (v149/*: any*/),
                        (v150/*: any*/),
                        (v152/*: any*/),
                        (v153/*: any*/),
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            (v72/*: any*/),
                            {
                              "concreteType": "JiraOptionConnection",
                              "kind": "LinkedField",
                              "name": "selectedOptions",
                              "plural": false,
                              "selections": [
                                {
                                  "concreteType": "JiraOptionEdge",
                                  "kind": "LinkedField",
                                  "name": "edges",
                                  "plural": true,
                                  "selections": [
                                    (v154/*: any*/),
                                    (v55/*: any*/)
                                  ]
                                }
                              ]
                            },
                            (v104/*: any*/)
                          ],
                          "type": "JiraCheckboxesField"
                        },
                        (v155/*: any*/),
                        (v156/*: any*/),
                        (v159/*: any*/),
                        (v160/*: any*/),
                        (v161/*: any*/),
                        (v163/*: any*/),
                        (v167/*: any*/),
                        (v171/*: any*/),
                        (v173/*: any*/),
                        (v175/*: any*/),
                        (v176/*: any*/),
                        (v177/*: any*/),
                        (v182/*: any*/),
                        (v55/*: any*/)
                      ]
                    }
                  ]
                }
              ]
            },
            (v55/*: any*/)
          ]
        }
      ]
    },
    {
      "condition": "shouldQueryConditionalFormatting",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "concreteType": "JiraIssueFieldSetEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraIssueFieldSet",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JiraIssueFieldConnection",
                  "kind": "LinkedField",
                  "name": "fields",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "JiraIssueFieldEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "args": (v108/*: any*/),
                                  "concreteType": "JiraComponentConnection",
                                  "kind": "LinkedField",
                                  "name": "selectedComponentsConnection",
                                  "plural": false,
                                  "selections": [
                                    {
                                      "concreteType": "JiraComponentEdge",
                                      "kind": "LinkedField",
                                      "name": "edges",
                                      "plural": true,
                                      "selections": [
                                        {
                                          "concreteType": "JiraComponent",
                                          "kind": "LinkedField",
                                          "name": "node",
                                          "plural": false,
                                          "selections": [
                                            {
                                              "kind": "ScalarField",
                                              "name": "componentId"
                                            }
                                          ]
                                        }
                                      ]
                                    }
                                  ],
                                  "storageKey": "selectedComponentsConnection(first:1000)"
                                }
                              ],
                              "type": "JiraComponentsField"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "concreteType": "JiraPriority",
                                  "kind": "LinkedField",
                                  "name": "priority",
                                  "plural": false,
                                  "selections": [
                                    (v183/*: any*/)
                                  ]
                                }
                              ],
                              "type": "JiraPriorityField"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "concreteType": "JiraProject",
                                  "kind": "LinkedField",
                                  "name": "project",
                                  "plural": false,
                                  "selections": [
                                    (v184/*: any*/)
                                  ]
                                }
                              ],
                              "type": "JiraProjectField"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "concreteType": "JiraVersion",
                                  "kind": "LinkedField",
                                  "name": "version",
                                  "plural": false,
                                  "selections": [
                                    (v162/*: any*/),
                                    (v41/*: any*/)
                                  ]
                                }
                              ],
                              "type": "JiraSingleVersionPickerField"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "concreteType": "JiraIssueType",
                                  "kind": "LinkedField",
                                  "name": "issueType",
                                  "plural": false,
                                  "selections": [
                                    (v128/*: any*/)
                                  ]
                                }
                              ],
                              "type": "JiraIssueTypeField"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "kind": "LinkedField",
                                  "name": "selectedValue",
                                  "plural": false,
                                  "selections": (v185/*: any*/)
                                }
                              ],
                              "type": "JiraSingleSelectField"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "concreteType": "JiraSelectableValueConnection",
                                  "kind": "LinkedField",
                                  "name": "selectedValues",
                                  "plural": false,
                                  "selections": [
                                    {
                                      "concreteType": "JiraSelectableValueEdge",
                                      "kind": "LinkedField",
                                      "name": "edges",
                                      "plural": true,
                                      "selections": [
                                        {
                                          "kind": "LinkedField",
                                          "name": "node",
                                          "plural": false,
                                          "selections": (v185/*: any*/)
                                        }
                                      ]
                                    }
                                  ]
                                }
                              ],
                              "type": "JiraMultipleSelectField"
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "storageKey": "fieldSets(first:500)"
},
v187 = {
  "kind": "ScalarField",
  "name": "endCursor"
},
v188 = {
  "kind": "ScalarField",
  "name": "hasNextPage"
},
v189 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    (v187/*: any*/),
    {
      "kind": "ScalarField",
      "name": "startCursor"
    },
    (v188/*: any*/),
    {
      "kind": "ScalarField",
      "name": "hasPreviousPage"
    }
  ]
},
v190 = {
  "concreteType": "JiraIssueNavigatorPageInfo",
  "kind": "LinkedField",
  "name": "issueNavigatorPageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "firstIssuePosition"
    },
    {
      "kind": "ScalarField",
      "name": "lastIssuePosition"
    }
  ]
},
v191 = {
  "kind": "ScalarField",
  "name": "pageNumber"
},
v192 = {
  "kind": "ScalarField",
  "name": "isCurrent"
},
v193 = [
  (v191/*: any*/),
  (v83/*: any*/),
  (v192/*: any*/)
],
v194 = {
  "args": [
    {
      "kind": "Literal",
      "name": "maxCursors",
      "value": 7
    }
  ],
  "concreteType": "JiraPageCursors",
  "kind": "LinkedField",
  "name": "pageCursors",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraPageCursor",
      "kind": "LinkedField",
      "name": "around",
      "plural": true,
      "selections": (v193/*: any*/)
    },
    {
      "concreteType": "JiraPageCursor",
      "kind": "LinkedField",
      "name": "last",
      "plural": false,
      "selections": (v193/*: any*/)
    },
    {
      "concreteType": "JiraPageCursor",
      "kind": "LinkedField",
      "name": "first",
      "plural": false,
      "selections": [
        (v83/*: any*/),
        (v191/*: any*/),
        (v192/*: any*/)
      ]
    }
  ],
  "storageKey": "pageCursors(maxCursors:7)"
},
v195 = {
  "kind": "ScalarField",
  "name": "totalIssueSearchResultCount"
},
v196 = {
  "kind": "LinkedField",
  "name": "issueSearchError",
  "plural": false,
  "selections": [
    (v38/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "messages"
        }
      ],
      "type": "JiraInvalidJqlError"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v39/*: any*/),
        {
          "kind": "ScalarField",
          "name": "errorType"
        }
      ],
      "type": "JiraInvalidSyntaxError"
    },
    {
      "kind": "InlineFragment",
      "selections": (v106/*: any*/),
      "type": "JiraServerError"
    }
  ]
},
v197 = {
  "kind": "ScalarField",
  "name": "isCappingIssueSearchResult"
},
v198 = {
  "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcfrontierformulafieldd1relayprovider",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "concreteType": "JiraIssueEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "JiraIssue",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v96/*: any*/)
          ]
        }
      ]
    }
  ]
},
v199 = {
  "args": (v82/*: any*/),
  "concreteType": "JiraIssueConnection",
  "kind": "LinkedField",
  "name": "issues",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraIssueEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        (v83/*: any*/),
        (v98/*: any*/),
        (v38/*: any*/),
        (v186/*: any*/),
        (v55/*: any*/)
      ]
    },
    (v189/*: any*/),
    (v190/*: any*/),
    (v194/*: any*/),
    (v195/*: any*/),
    (v196/*: any*/),
    (v45/*: any*/),
    (v197/*: any*/),
    (v55/*: any*/),
    (v198/*: any*/)
  ]
},
v200 = [
  "scope"
],
v201 = {
  "kind": "Variable",
  "name": "__dynamicKey",
  "variableName": "dynamicSearchKey"
},
v202 = [
  "issueSearchInput"
],
v203 = [
  (v75/*: any*/),
  (v76/*: any*/),
  (v78/*: any*/),
  (v48/*: any*/),
  (v35/*: any*/),
  (v79/*: any*/),
  (v81/*: any*/),
  (v36/*: any*/),
  (v37/*: any*/)
],
v204 = {
  "kind": "ScalarField",
  "name": "fieldType"
},
v205 = {
  "kind": "LinkedField",
  "name": "fieldValue",
  "plural": false,
  "selections": [
    (v38/*: any*/),
    (v61/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraPriority",
          "kind": "LinkedField",
          "name": "priority",
          "plural": false,
          "selections": [
            (v41/*: any*/),
            (v183/*: any*/),
            (v72/*: any*/),
            (v131/*: any*/)
          ]
        },
        (v60/*: any*/)
      ],
      "type": "JiraJqlPriorityFieldValue"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            (v38/*: any*/),
            (v41/*: any*/),
            (v139/*: any*/),
            (v72/*: any*/),
            (v137/*: any*/)
          ]
        },
        (v60/*: any*/)
      ],
      "type": "JiraJqlUserFieldValue"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraStatus",
          "kind": "LinkedField",
          "name": "status",
          "plural": false,
          "selections": [
            (v41/*: any*/),
            (v72/*: any*/),
            (v129/*: any*/)
          ]
        },
        (v60/*: any*/),
        (v90/*: any*/)
      ],
      "type": "JiraJqlStatusFieldValue"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v147/*: any*/)
      ],
      "type": "JiraJqlNumberFieldValue"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraOption",
          "kind": "LinkedField",
          "name": "option",
          "plural": false,
          "selections": [
            (v41/*: any*/),
            (v151/*: any*/),
            (v64/*: any*/),
            (v122/*: any*/)
          ]
        },
        (v60/*: any*/)
      ],
      "type": "JiraJqlOptionFieldValue"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraSprint",
          "kind": "LinkedField",
          "name": "sprint",
          "plural": false,
          "selections": (v135/*: any*/)
        },
        (v60/*: any*/)
      ],
      "type": "JiraJqlSprintFieldValue"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraLabel",
          "kind": "LinkedField",
          "name": "label",
          "plural": false,
          "selections": (v123/*: any*/)
        }
      ],
      "type": "JiraJqlLabelFieldValue"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraGroup",
          "kind": "LinkedField",
          "name": "group",
          "plural": false,
          "selections": [
            (v41/*: any*/),
            (v174/*: any*/),
            (v72/*: any*/)
          ]
        }
      ],
      "type": "JiraJqlGroupFieldValue"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraVersion",
          "kind": "LinkedField",
          "name": "version",
          "plural": false,
          "selections": [
            (v41/*: any*/),
            (v162/*: any*/),
            (v72/*: any*/)
          ]
        },
        (v60/*: any*/)
      ],
      "type": "JiraJqlVersionFieldValue"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v60/*: any*/),
        {
          "concreteType": "JiraGoal",
          "kind": "LinkedField",
          "name": "goal",
          "plural": false,
          "selections": [
            (v166/*: any*/),
            {
              "kind": "ScalarField",
              "name": "score"
            },
            (v41/*: any*/),
            {
              "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalgroupheadersmartlinkrelayprovider",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                (v84/*: any*/),
                (v72/*: any*/)
              ]
            }
          ]
        }
      ],
      "type": "JiraJqlGoalsFieldValue"
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyprojectsrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "concreteType": "JiraTownsquareProject",
              "kind": "LinkedField",
              "name": "project",
              "plural": false,
              "selections": [
                (v41/*: any*/),
                (v84/*: any*/),
                (v168/*: any*/),
                (v169/*: any*/),
                (v72/*: any*/),
                (v170/*: any*/)
              ]
            }
          ],
          "type": "JiraJqlTownsquareProjectFieldValue"
        }
      ]
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraIssueType",
          "kind": "LinkedField",
          "name": "issueTypes",
          "plural": true,
          "selections": [
            (v72/*: any*/),
            (v97/*: any*/),
            (v41/*: any*/),
            (v128/*: any*/),
            (v86/*: any*/)
          ]
        }
      ],
      "type": "JiraJqlIssueTypeFieldValue"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v60/*: any*/),
        {
          "concreteType": "JiraResolution",
          "kind": "LinkedField",
          "name": "resolution",
          "plural": false,
          "selections": [
            (v41/*: any*/),
            (v72/*: any*/)
          ]
        }
      ],
      "type": "JiraJqlResolutionFieldValue"
    }
  ]
},
v206 = {
  "kind": "ScalarField",
  "name": "issueCount"
},
v207 = {
  "kind": "Variable",
  "name": "viewConfigInput",
  "variableName": "viewConfigInput"
},
v208 = [
  (v77/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 50
  },
  (v42/*: any*/),
  (v37/*: any*/),
  (v207/*: any*/)
],
v209 = {
  "args": (v203/*: any*/),
  "concreteType": "JiraSpreadsheetGroupConnection",
  "kind": "LinkedField",
  "name": "groups",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraSpreadsheetGroupEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        (v83/*: any*/),
        {
          "concreteType": "JiraSpreadsheetGroup",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v38/*: any*/),
            (v41/*: any*/),
            (v45/*: any*/),
            (v50/*: any*/),
            (v204/*: any*/),
            (v44/*: any*/),
            (v205/*: any*/),
            (v206/*: any*/)
          ]
        },
        (v38/*: any*/)
      ]
    },
    (v189/*: any*/),
    {
      "kind": "ScalarField",
      "name": "groupByField"
    },
    (v45/*: any*/),
    {
      "concreteType": "QueryError",
      "kind": "LinkedField",
      "name": "errors",
      "plural": true,
      "selections": (v40/*: any*/)
    },
    {
      "condition": "isPaginating",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "concreteType": "JiraSpreadsheetGroup",
          "kind": "LinkedField",
          "name": "firstGroup",
          "plural": false,
          "selections": [
            (v41/*: any*/),
            {
              "args": (v208/*: any*/),
              "concreteType": "JiraIssueConnection",
              "kind": "LinkedField",
              "name": "issues",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JiraIssueEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    (v38/*: any*/),
                    (v83/*: any*/),
                    {
                      "concreteType": "JiraIssue",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        (v38/*: any*/),
                        (v41/*: any*/),
                        (v85/*: any*/),
                        (v84/*: any*/),
                        (v87/*: any*/),
                        (v88/*: any*/),
                        (v92/*: any*/),
                        (v94/*: any*/),
                        (v95/*: any*/)
                      ]
                    },
                    {
                      "args": (v99/*: any*/),
                      "concreteType": "JiraIssueFieldSetConnection",
                      "kind": "LinkedField",
                      "name": "fieldSets",
                      "plural": false,
                      "selections": [
                        {
                          "concreteType": "JiraIssueFieldSetEdge",
                          "kind": "LinkedField",
                          "name": "edges",
                          "plural": true,
                          "selections": [
                            {
                              "concreteType": "JiraIssueFieldSet",
                              "kind": "LinkedField",
                              "name": "node",
                              "plural": false,
                              "selections": [
                                (v59/*: any*/),
                                (v44/*: any*/),
                                {
                                  "concreteType": "JiraIssueFieldConnection",
                                  "kind": "LinkedField",
                                  "name": "fields",
                                  "plural": false,
                                  "selections": [
                                    (v58/*: any*/),
                                    {
                                      "concreteType": "JiraIssueFieldEdge",
                                      "kind": "LinkedField",
                                      "name": "edges",
                                      "plural": true,
                                      "selections": [
                                        {
                                          "kind": "LinkedField",
                                          "name": "node",
                                          "plural": false,
                                          "selections": [
                                            (v41/*: any*/),
                                            (v38/*: any*/),
                                            (v50/*: any*/),
                                            (v59/*: any*/),
                                            (v100/*: any*/),
                                            (v101/*: any*/),
                                            (v105/*: any*/),
                                            (v107/*: any*/),
                                            (v111/*: any*/),
                                            (v114/*: any*/),
                                            (v115/*: any*/),
                                            (v116/*: any*/),
                                            (v117/*: any*/),
                                            (v119/*: any*/),
                                            (v120/*: any*/),
                                            (v121/*: any*/),
                                            (v124/*: any*/),
                                            (v125/*: any*/),
                                            (v130/*: any*/),
                                            (v132/*: any*/),
                                            (v133/*: any*/),
                                            (v134/*: any*/),
                                            (v136/*: any*/),
                                            {
                                              "kind": "InlineFragment",
                                              "selections": [
                                                (v72/*: any*/),
                                                {
                                                  "kind": "LinkedField",
                                                  "name": "user",
                                                  "plural": false,
                                                  "selections": [
                                                    (v38/*: any*/),
                                                    (v72/*: any*/),
                                                    (v137/*: any*/),
                                                    (v138/*: any*/),
                                                    (v41/*: any*/),
                                                    (v139/*: any*/),
                                                    (v142/*: any*/),
                                                    (v143/*: any*/)
                                                  ]
                                                },
                                                (v113/*: any*/),
                                                (v104/*: any*/)
                                              ],
                                              "type": "JiraSingleSelectUserPickerField"
                                            },
                                            (v144/*: any*/),
                                            (v145/*: any*/),
                                            (v146/*: any*/),
                                            (v148/*: any*/),
                                            (v149/*: any*/),
                                            (v150/*: any*/),
                                            (v152/*: any*/),
                                            (v153/*: any*/),
                                            {
                                              "kind": "InlineFragment",
                                              "selections": [
                                                (v72/*: any*/),
                                                {
                                                  "concreteType": "JiraOptionConnection",
                                                  "kind": "LinkedField",
                                                  "name": "selectedOptions",
                                                  "plural": false,
                                                  "selections": [
                                                    {
                                                      "concreteType": "JiraOptionEdge",
                                                      "kind": "LinkedField",
                                                      "name": "edges",
                                                      "plural": true,
                                                      "selections": [
                                                        (v154/*: any*/)
                                                      ]
                                                    }
                                                  ]
                                                },
                                                (v104/*: any*/)
                                              ],
                                              "type": "JiraCheckboxesField"
                                            },
                                            (v155/*: any*/),
                                            (v156/*: any*/),
                                            (v159/*: any*/),
                                            (v160/*: any*/),
                                            (v161/*: any*/),
                                            (v163/*: any*/),
                                            (v167/*: any*/),
                                            (v171/*: any*/),
                                            (v173/*: any*/),
                                            (v175/*: any*/),
                                            (v176/*: any*/),
                                            (v177/*: any*/),
                                            (v182/*: any*/),
                                            (v55/*: any*/)
                                          ]
                                        }
                                      ]
                                    }
                                  ]
                                }
                              ]
                            }
                          ]
                        }
                      ],
                      "storageKey": "fieldSets(first:500)"
                    },
                    (v55/*: any*/)
                  ]
                },
                {
                  "concreteType": "PageInfo",
                  "kind": "LinkedField",
                  "name": "pageInfo",
                  "plural": false,
                  "selections": [
                    (v187/*: any*/),
                    (v188/*: any*/)
                  ]
                },
                (v195/*: any*/),
                (v197/*: any*/),
                (v55/*: any*/)
              ]
            },
            {
              "args": (v208/*: any*/),
              "filters": [
                "viewConfigInput",
                "fieldSetsInput",
                "scope",
                "settings"
              ],
              "handle": "connection",
              "key": "firstGroupSection_nativeIssueTable__issues",
              "kind": "LinkedHandle",
              "name": "issues"
            },
            (v45/*: any*/),
            (v50/*: any*/),
            (v204/*: any*/),
            (v44/*: any*/),
            (v205/*: any*/),
            (v206/*: any*/)
          ]
        }
      ]
    },
    (v55/*: any*/)
  ]
},
v210 = [
  (v75/*: any*/),
  (v76/*: any*/),
  (v77/*: any*/),
  (v78/*: any*/),
  (v35/*: any*/),
  (v79/*: any*/),
  (v80/*: any*/),
  (v81/*: any*/),
  (v36/*: any*/),
  (v37/*: any*/),
  (v207/*: any*/)
],
v211 = {
  "args": (v210/*: any*/),
  "concreteType": "JiraIssueConnection",
  "kind": "LinkedField",
  "name": "issues",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraIssueEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        (v83/*: any*/),
        (v98/*: any*/),
        (v38/*: any*/),
        (v186/*: any*/),
        {
          "condition": "shouldQueryHasChildren",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "args": [
                {
                  "items": [
                    {
                      "kind": "Variable",
                      "name": "filterByProjectKeys.0",
                      "variableName": "projectKey"
                    }
                  ],
                  "kind": "ListValue",
                  "name": "filterByProjectKeys"
                }
              ],
              "kind": "ScalarField",
              "name": "hasChildren"
            },
            {
              "args": [
                (v30/*: any*/)
              ],
              "kind": "ScalarField",
              "name": "canHaveChildIssues"
            }
          ]
        },
        (v55/*: any*/)
      ]
    },
    (v189/*: any*/),
    (v190/*: any*/),
    (v194/*: any*/),
    (v195/*: any*/),
    (v196/*: any*/),
    (v45/*: any*/),
    (v197/*: any*/),
    (v55/*: any*/),
    (v198/*: any*/)
  ]
},
v212 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "feature",
        "variableName": "atlassianIntelligenceProductFeature"
      }
    ],
    "kind": "ObjectValue",
    "name": "atlassianIntelligenceProductFeatureInput"
  },
  (v31/*: any*/)
],
v213 = [
  {
    "kind": "ScalarField",
    "name": "canPerform"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      (v18/*: any*/),
      (v19/*: any*/),
      (v20/*: any*/),
      (v21/*: any*/),
      (v22/*: any*/),
      (v23/*: any*/),
      (v24/*: any*/),
      (v25/*: any*/),
      (v26/*: any*/),
      (v27/*: any*/)
    ],
    "kind": "Fragment",
    "name": "main_IssueNavigatorQuery",
    "selections": [
      {
        "args": [
          (v28/*: any*/),
          (v29/*: any*/),
          (v30/*: any*/),
          {
            "items": [
              {
                "kind": "Variable",
                "name": "projectKeys.0",
                "variableName": "projectKey"
              }
            ],
            "kind": "ListValue",
            "name": "projectKeys"
          }
        ],
        "kind": "FragmentSpread",
        "name": "main_issueNavigator_IssueNavigator_issueQuery"
      },
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v32/*: any*/),
            "concreteType": "JiraUserPreferences",
            "kind": "LinkedField",
            "name": "userPreferences",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "main_issueNavigator_IssueNavigator_userPreferences"
              }
            ]
          },
          {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_IssueNavigator_jira"
          },
          {
            "condition": "shouldQueryProject",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": (v33/*: any*/),
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "jiraProjectByKey",
                "plural": false,
                "selections": [
                  {
                    "args": [
                      (v28/*: any*/),
                      (v29/*: any*/)
                    ],
                    "kind": "FragmentSpread",
                    "name": "main_issueNavigator_IssueNavigatorUI_project"
                  },
                  {
                    "kind": "FragmentSpread",
                    "name": "issueSearch_issueNavigatorProject"
                  },
                  {
                    "condition": "shouldQueryConditionalFormattingFromSavedView",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                      {
                        "condition": "shouldQueryConditionalFormatting",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "args": (v34/*: any*/),
                            "kind": "FragmentSpread",
                            "name": "container_issueNavigatorActionConditionalFormatting_ConditionalFormattingInner"
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "condition": "shouldQueryConditionalFormattingFromSavedView",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "kind": "FragmentSpread",
                        "name": "ConditionalFormattingSidebarContainer_project"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v12/*: any*/),
      (v9/*: any*/),
      (v14/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/),
      (v15/*: any*/),
      (v27/*: any*/),
      (v16/*: any*/),
      (v6/*: any*/),
      (v8/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v17/*: any*/),
      (v24/*: any*/),
      (v21/*: any*/),
      (v22/*: any*/),
      (v11/*: any*/),
      (v25/*: any*/),
      (v26/*: any*/),
      (v19/*: any*/),
      (v10/*: any*/),
      (v23/*: any*/),
      (v7/*: any*/),
      (v13/*: any*/),
      (v20/*: any*/),
      (v18/*: any*/),
      (v5/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraninlastusedjqlrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisfrozencolumnsenabledrelayprovidertsx"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcbulkopsselectallrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscissuerankingrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewconditionalformattingenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcfrontierformulafieldd1relayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcmimicflatlistrsswhileuninitialisedrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreducererendersrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaifetchapptypeforuserassigneerelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerninrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyprojectsrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalgroupheadersmartlinkrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjirapaidlistninmergeonboardingmodalenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesdogfoodingormergesupportenabledrelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "main_IssueNavigatorQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": [
              (v31/*: any*/),
              {
                "kind": "Variable",
                "name": "filterId",
                "variableName": "filterId"
              },
              (v35/*: any*/),
              {
                "kind": "Variable",
                "name": "jiraViewQueryInput",
                "variableName": "jiraViewQueryInput"
              },
              {
                "kind": "Variable",
                "name": "namespace",
                "variableName": "namespace"
              },
              (v36/*: any*/),
              (v37/*: any*/),
              {
                "kind": "Variable",
                "name": "viewConfigInput",
                "variableName": "staticViewInput"
              },
              {
                "kind": "Variable",
                "name": "viewId",
                "variableName": "viewId"
              }
            ],
            "kind": "LinkedField",
            "name": "jiraIssueSearchView",
            "plural": false,
            "selections": [
              (v38/*: any*/),
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isJiraView"
              },
              {
                "concreteType": "QueryError",
                "kind": "LinkedField",
                "name": "error",
                "plural": false,
                "selections": (v40/*: any*/)
              },
              (v41/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "viewId"
                  },
                  {
                    "args": (v43/*: any*/),
                    "concreteType": "JiraIssueSearchFieldSetConnection",
                    "kind": "LinkedField",
                    "name": "fieldSets",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraIssueSearchFieldSetEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "JiraIssueSearchFieldSet",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v44/*: any*/),
                              {
                                "concreteType": "JiraFieldSetPreferences",
                                "kind": "LinkedField",
                                "name": "fieldSetPreferences",
                                "plural": false,
                                "selections": [
                                  {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisfrozencolumnsenabledrelayprovidertsx",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "isFrozen"
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraninlastusedjqlrelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      (v45/*: any*/)
                    ]
                  },
                  {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewenabledrelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "canPublishViewConfig"
                      },
                      (v46/*: any*/),
                      (v47/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "args": (v49/*: any*/),
                            "concreteType": "JiraIssueSearchViewConfigSettings",
                            "kind": "LinkedField",
                            "name": "viewSettings",
                            "plural": false,
                            "selections": [
                              (v51/*: any*/),
                              (v52/*: any*/),
                              (v53/*: any*/)
                            ]
                          }
                        ],
                        "type": "JiraSpreadsheetView",
                        "abstractKey": "__isJiraSpreadsheetView"
                      },
                      (v55/*: any*/)
                    ]
                  },
                  {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      (v46/*: any*/)
                    ]
                  }
                ],
                "type": "JiraIssueSearchViewMetadata",
                "abstractKey": "__isJiraIssueSearchViewMetadata"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "args": (v49/*: any*/),
                    "concreteType": "JiraIssueSearchViewConfigSettings",
                    "kind": "LinkedField",
                    "name": "viewSettings",
                    "plural": false,
                    "selections": [
                      (v56/*: any*/),
                      (v57/*: any*/),
                      (v51/*: any*/),
                      (v53/*: any*/),
                      (v52/*: any*/)
                    ]
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "args": [
                          (v42/*: any*/)
                        ],
                        "kind": "ScalarField",
                        "name": "hasDefaultFieldSets"
                      },
                      {
                        "args": (v43/*: any*/),
                        "concreteType": "JiraIssueSearchFieldSetConnection",
                        "kind": "LinkedField",
                        "name": "fieldSets",
                        "plural": false,
                        "selections": [
                          (v58/*: any*/),
                          {
                            "concreteType": "JiraIssueSearchFieldSetEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "JiraIssueSearchFieldSet",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraFieldSetPreferences",
                                    "kind": "LinkedField",
                                    "name": "fieldSetPreferences",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "width"
                                      }
                                    ]
                                  },
                                  (v59/*: any*/),
                                  (v60/*: any*/),
                                  (v61/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "isSortable"
                                  },
                                  {
                                    "concreteType": "JiraFieldType",
                                    "kind": "LinkedField",
                                    "name": "fieldType",
                                    "plural": false,
                                    "selections": [
                                      (v60/*: any*/)
                                    ]
                                  },
                                  (v62/*: any*/),
                                  {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                      {
                                        "concreteType": "JiraIssueSearchFieldMetadataConnection",
                                        "kind": "LinkedField",
                                        "name": "fieldsMetadata",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "JiraIssueSearchFieldMetadataEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "JiraIssueSearchMetadataField",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "canBeConfigured"
                                                  },
                                                  (v50/*: any*/)
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  {
                                    "kind": "ClientExtension",
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "isPlaceHolderField"
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          (v55/*: any*/)
                        ]
                      },
                      {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          (v47/*: any*/)
                        ]
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "args": (v49/*: any*/),
                            "concreteType": "JiraIssueSearchViewConfigSettings",
                            "kind": "LinkedField",
                            "name": "viewSettings",
                            "plural": false,
                            "selections": [
                              (v53/*: any*/),
                              (v63/*: any*/),
                              (v56/*: any*/),
                              (v57/*: any*/),
                              (v52/*: any*/),
                              (v51/*: any*/),
                              {
                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscissuerankingrelayprovider",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "canEnableReranking"
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "args": (v34/*: any*/),
                                "concreteType": "JiraFormattingRuleConnection",
                                "kind": "LinkedField",
                                "name": "conditionalFormattingRules",
                                "plural": false,
                                "selections": [
                                  {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewconditionalformattingenabledrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": (v71/*: any*/)
                                  }
                                ],
                                "storageKey": "conditionalFormattingRules(first:20)"
                              }
                            ]
                          }
                        ],
                        "type": "JiraSpreadsheetView",
                        "abstractKey": "__isJiraSpreadsheetView"
                      },
                      (v55/*: any*/)
                    ],
                    "type": "JiraIssueSearchViewMetadata",
                    "abstractKey": "__isJiraIssueSearchViewMetadata"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v45/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "filterId"
                          },
                          {
                            "args": (v49/*: any*/),
                            "concreteType": "JiraIssueSearchViewConfigSettings",
                            "kind": "LinkedField",
                            "name": "viewSettings",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "JiraSpreadsheetGroupByConfig",
                                "kind": "LinkedField",
                                "name": "groupByConfig",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraField",
                                    "kind": "LinkedField",
                                    "name": "groupByField",
                                    "plural": false,
                                    "selections": [
                                      (v72/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "typeKey"
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ],
                        "type": "JiraSpreadsheetView",
                        "abstractKey": "__isJiraSpreadsheetView"
                      }
                    ],
                    "type": "JiraView",
                    "abstractKey": "__isJiraView"
                  },
                  {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcbulkopsselectallrelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "args": (v49/*: any*/),
                        "concreteType": "JiraIssueSearchViewConfigSettings",
                        "kind": "LinkedField",
                        "name": "viewSettings",
                        "plural": false,
                        "selections": [
                          (v63/*: any*/)
                        ]
                      }
                    ]
                  },
                  {
                    "condition": "shouldQueryConditionalFormattingFromSavedView",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      (v46/*: any*/),
                      {
                        "args": (v34/*: any*/),
                        "concreteType": "JiraFormattingRuleConnection",
                        "kind": "LinkedField",
                        "name": "conditionalFormattingRules",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "JiraFormattingRuleEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "JiraFormattingRule",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v41/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "name": "expression",
                                    "plural": false,
                                    "selections": [
                                      (v38/*: any*/),
                                      (v66/*: any*/),
                                      (v65/*: any*/),
                                      (v67/*: any*/)
                                    ]
                                  },
                                  (v74/*: any*/),
                                  (v69/*: any*/)
                                ]
                              },
                              (v38/*: any*/)
                            ]
                          },
                          (v55/*: any*/)
                        ],
                        "storageKey": "conditionalFormattingRules(first:20)"
                      },
                      (v55/*: any*/)
                    ]
                  }
                ],
                "type": "JiraSpreadsheetView",
                "abstractKey": "__isJiraSpreadsheetView"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraninlastusedjqlrelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      (v199/*: any*/),
                      {
                        "args": (v82/*: any*/),
                        "filters": (v200/*: any*/),
                        "handle": "connection",
                        "key": "IssueNavigatorJiraDetailedViewPagination__issues",
                        "kind": "LinkedHandle",
                        "name": "issues",
                        "dynamicKey": (v201/*: any*/)
                      }
                    ]
                  },
                  {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraninlastusedjqlrelayprovider",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                      (v199/*: any*/),
                      {
                        "args": (v82/*: any*/),
                        "filters": (v202/*: any*/),
                        "handle": "connection",
                        "key": "IssueNavigatorDetailedViewPagination__issues",
                        "kind": "LinkedHandle",
                        "name": "issues"
                      }
                    ]
                  }
                ],
                "type": "JiraDetailedView"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraninlastusedjqlrelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      (v209/*: any*/),
                      {
                        "args": (v203/*: any*/),
                        "filters": (v200/*: any*/),
                        "handle": "connection",
                        "key": "IssueNavigatorJiraGroupedListViewPagination__groups",
                        "kind": "LinkedHandle",
                        "name": "groups",
                        "dynamicKey": (v201/*: any*/)
                      }
                    ]
                  },
                  {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraninlastusedjqlrelayprovider",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                      (v209/*: any*/),
                      {
                        "args": (v203/*: any*/),
                        "filters": (v202/*: any*/),
                        "handle": "connection",
                        "key": "IssueNavigatorGroupedListViewPagination__groups",
                        "kind": "LinkedHandle",
                        "name": "groups"
                      }
                    ]
                  }
                ],
                "type": "JiraGroupedListView"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraninlastusedjqlrelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      (v211/*: any*/),
                      {
                        "args": (v210/*: any*/),
                        "filters": (v200/*: any*/),
                        "handle": "connection",
                        "key": "IssueNavigatorJiraListViewPagination__issues",
                        "kind": "LinkedHandle",
                        "name": "issues",
                        "dynamicKey": (v201/*: any*/)
                      }
                    ]
                  },
                  {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraninlastusedjqlrelayprovider",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                      (v211/*: any*/),
                      {
                        "args": (v210/*: any*/),
                        "filters": (v202/*: any*/),
                        "handle": "connection",
                        "key": "IssueNavigatorListViewPagination__issues",
                        "kind": "LinkedHandle",
                        "name": "issues"
                      }
                    ]
                  }
                ],
                "type": "JiraListView"
              }
            ]
          },
          {
            "args": (v32/*: any*/),
            "concreteType": "JiraUserPreferences",
            "kind": "LinkedField",
            "name": "userPreferences",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "jqlBuilderSearchMode"
              },
              (v55/*: any*/),
              {
                "kind": "ScalarField",
                "name": "isNaturalLanguageSpotlightTourEnabled"
              }
            ]
          },
          {
            "args": (v212/*: any*/),
            "kind": "ScalarField",
            "name": "shouldShowAtlassianIntelligence"
          },
          {
            "args": (v212/*: any*/),
            "kind": "LinkedField",
            "name": "atlassianIntelligenceAction",
            "plural": false,
            "selections": [
              (v38/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "isAccessible"
                  }
                ],
                "type": "JiraAccessAtlassianIntelligenceFeature"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "link"
                  }
                ],
                "type": "JiraEnableAtlassianIntelligenceDeepLink"
              }
            ]
          },
          {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscissuerankingrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": (v32/*: any*/),
                "concreteType": "JiraJqlFieldWithAliases",
                "kind": "LinkedField",
                "name": "rankField",
                "plural": false,
                "selections": [
                  (v50/*: any*/),
                  (v61/*: any*/),
                  (v62/*: any*/)
                ]
              }
            ]
          },
          {
            "condition": "shouldQueryProject",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": (v33/*: any*/),
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "jiraProjectByKey",
                "plural": false,
                "selections": [
                  (v84/*: any*/),
                  (v184/*: any*/),
                  {
                    "alias": "createIssues",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "type",
                        "value": "CREATE_ISSUES"
                      }
                    ],
                    "concreteType": "JiraProjectAction",
                    "kind": "LinkedField",
                    "name": "action",
                    "plural": false,
                    "selections": (v213/*: any*/),
                    "storageKey": "action(type:\"CREATE_ISSUES\")"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "projectType"
                  },
                  (v41/*: any*/),
                  {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": "editIssues",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "type",
                            "value": "EDIT_ISSUES"
                          }
                        ],
                        "concreteType": "JiraProjectAction",
                        "kind": "LinkedField",
                        "name": "action",
                        "plural": false,
                        "selections": (v213/*: any*/),
                        "storageKey": "action(type:\"EDIT_ISSUES\")"
                      }
                    ]
                  },
                  {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewconditionalformattingenabledrelayprovider",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                      {
                        "condition": "shouldQueryConditionalFormatting",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "args": (v34/*: any*/),
                            "concreteType": "JiraFormattingRuleConnection",
                            "kind": "LinkedField",
                            "name": "conditionalFormattingRules",
                            "plural": false,
                            "selections": (v71/*: any*/),
                            "storageKey": "conditionalFormattingRules(first:20)"
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "condition": "shouldQueryConditionalFormattingFromSavedView",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                      {
                        "condition": "shouldQueryConditionalFormatting",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "args": (v34/*: any*/),
                            "concreteType": "JiraFormattingRuleConnection",
                            "kind": "LinkedField",
                            "name": "conditionalFormattingRules",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "JiraFormattingRuleEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "JiraFormattingRule",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v41/*: any*/),
                                      (v74/*: any*/),
                                      (v69/*: any*/),
                                      (v68/*: any*/)
                                    ]
                                  },
                                  (v38/*: any*/)
                                ]
                              }
                            ],
                            "storageKey": "conditionalFormattingRules(first:20)"
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjirapaidlistninmergeonboardingmodalenabledrelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": (v93/*: any*/)
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "52ad1f2cc6e3f90d2b258f01ac3517ee9db71895944a0d4acaf80ea8a4b4a7d1",
    "metadata": {},
    "name": "main_IssueNavigatorQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraninlastusedjqlrelayprovider": lastUsedJql_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider": isSavedListViewTechnicalChangesEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcisfrozencolumnsenabledrelayprovidertsx": isFrozenColumnsEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcbulkopsselectallrelayprovider": isBulkOpsSelectAllEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewenabledrelayprovider": isSavedListViewEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjscissuerankingrelayprovider": isIssueRankingEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider": isJscIFCEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider": isJSCAliasChangesEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewconditionalformattingenabledrelayprovider": isSavedViewConditionalFormattingEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider": isReparentingEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcfrontierformulafieldd1relayprovider": isFormulaFieldD1Enabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider": isInitialiseVirtualiserStateFromRelayStoreEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcmimicflatlistrsswhileuninitialisedrelayprovider": isMimicFlatlistRssWhileUninitialisedEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreducererendersrelayprovider": isJiraListReduceRerendersEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": isJscMergedColumnEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider": isJiraItrM4Exp3Enabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider": isIframePreviewPanelInSubtasksEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider": isJiraTimelineAnalyticsHarmonizationEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider": isAtlasProjectEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider": originalEstimateEditableFixFlag_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider": isFieldsByIdRemoved_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaifetchapptypeforuserassigneerelayprovider": shouldFetchAppUserType_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider": isJiraAiAgentAvatarSingleUserPickerEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider": isNinStrikethroughResolutionUpdateEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": isNumberFieldConfigurableEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider": isPlaceholderDataEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider": isJiraConfluencePageContentEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider": isJiraTimelineRollupsTechnicalGateEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerninrelayprovider": isJiraAiAgentAvatarSingleUserPickerNINEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyprojectsrelayprovider": isGroupByProjectsEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcgoalgroupheadersmartlinkrelayprovider": isGoalSmartLinkEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcisjirapaidlistninmergeonboardingmodalenabledrelayprovider": isPaidListNinMergeOnboardingModalEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesdogfoodingormergesupportenabledrelayprovider": isSavedListViewTechnicalChangesDogfoodingOrMergeSupportEnabled_provider
    }
  }
};
})();

(node as any).hash = "1bcae1f54d4fc39a84e9c70678ce0a01";

export default node;
